<template>
  <div class="listItem">
    <!-- {{ datas }} -->
    <p class="title menuTitle">{{ datas?.name }}</p>
    <van-divider :style="{ color: '#999', borderColor: '#999', padding: '0px', margin: '10px 0' }" />
    <template v-if="hasChidrenType(datas)">
      <div v-for="(item, index) in datas.subCategories" :key="item.identifier + index">
        <p class="title menuItemTitle themeColor">{{ item?.name }}</p>
        <menuLabel :datas="item.subCategories" :pid="item.identifier" :gid="datas.identifier" />
      </div>
    </template>
    <template v-else>
      <menuLabel :datas="datas.subCategories" :pid="datas.identifier" :gid="datas.identifier" />
    </template>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import menuLabel from '@/components/shop/Label'

export default {
  name: 'MenuListItem',
  components: { menuLabel },
  props: {
    datas: {
      default: () => ({}),
      type: Object
    }
  },
  setup(props, { emit }) {
    let store = useStore()
    let { datas } = toRefs(props)
    const state = reactive({
      datas
    })
    const hasChidrenType = datas => {
      return datas.subCategories.find(item => item.subCategories && item.subCategories.length)
    }
    onMounted(async () => {})
    return {
      ...toRefs(state),
      hasChidrenType
    }
  }
}
</script>

<style lang="scss" scoped>
.listItem {
  margin-bottom: 15px;
  text-align: left;
  .title {
    padding: 0 16px;
    font-weight: 600;
  }
  .menuTitle {
    color: #333;
  }

  .menuItemTitle {
    margin: 10px 0;
  }
}
</style>
